import React, { Fragment } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText'
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Box from '@material-ui/core/Box';
import DefaultSettings from './settings';
import { Button, ButtonGroup, Fab, Icon, Typography } from '@material-ui/core';
// import AssessmentIcon from '@material-ui/icons/Assessment';
import HowToRegSharpIcon from '@material-ui/icons/HowToRegSharp';

// const useStyles = makeStyles((theme) => ({
//     root: {
//         // "& .MuiTypography-body1": {
//         //     //color: 'rgba(0, 0, 0, 0.54)',
//         //     fontSize: 12,
//         //     fontWeight: 'bold'
//         // },
//         "& .MuiSvgIcon-root": {
//             height: '1 rem'
//         },


//     }
// }));


const defaults = {
    transformProps: {
        label: 'Name',
        value: 'Value'
    }
}

export default function CheckBox(props) {
    const { value, handleFieldValue, extraProps, shareProps, tooltip, contexthelp, required, className, disabled, error, ...otherProps } = props
    const { name, label, helperText, items, iconcolor, icontooltip, isicon, fullWidth, ...hiddenProps } = otherProps
    let { transformProps } = extraProps || {}
    transformProps = transformProps || defaults.transformProps
    let selecteditem = []
    let fieldval = (value === 'Y' || value === true) ? true : false;
    let fieldname = value ? (transformProps ? transformProps[value] : value) : false
    if (items && items.length > 0) {
        selecteditem = items && (items || []).filter((each) => {
            return (each[transformProps.value]) === value
        })
        fieldval = selecteditem && selecteditem.length > 0 && selecteditem[0].value || 'N'
        fieldname = selecteditem && selecteditem.length > 0 && selecteditem[0].name || false
    }
    // const classes = useStyles();
    let tlabel = (tooltip || contexthelp) ? <Typography variant='subtitle2' style={{ color: props.errors ? 'red' : disabled ? disabled : 'black' }}> {label}&nbsp; < Tooltip title={tooltip ? tooltip : null} placement="bottom-start" >
        <HelpOutlineIcon fontSize="small" style={{ width: '0.8em', color: '#007bff' }} onClick={(evt) => contexthelp ?
            DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
    </Tooltip> </Typography> : label;

    return (
        <Box className={className}>
            <FormControl fullWidth={fullWidth ? fullWidth : false} error={error} >
                <FormGroup >
                    <div className='row'>
                        <div className='col-12'>
                            <FormControlLabel
                                control={<Checkbox
                                    size='small'
                                    value={fieldval}
                                    // icon={<AssessmentIcon fontSize="small" />}
                                    // checkedIcon={<AssessmentIcon fontSize="small" />}
                                    checked={selecteditem && selecteditem.length > 0 ? (fieldname === 'true' || ((fieldname === 'Yes') ? true : false)) :
                                        (fieldname || ((fieldval === "N" || fieldval === false) ? false : true))}
                                    onChange={(evt) => {
                                        handleFieldValue({ target: { value: evt.target.value, name: name, checked: evt.target.checked }, currentTarget: { dataset: null } })
                                    }}
                                    name={name}
                                    color={disabled ? '' : 'primary'}
                                // className={classes.root}
                                />
                                }
                                style={{
                                    //color: 'rgba(0, 0, 0, 0.54)',
                                    fontSize: 12
                                }}
                                label={isicon ? '' : tlabel}
                                //  className={classes.root}
                                disabled={disabled}
                                {...hiddenProps}
                            />
                        </div>
                        {isicon &&
                            <div className='col-12'>
                                <Icon size="small" color={otherProps.iconcolor} className="float-right" title={otherProps.icontooltip}><HowToRegSharpIcon color={otherProps.iconcolor} fontSize="small" /></Icon>
                            </div>
                        }
                    </div>
                </FormGroup >
                {helperText && <FormHelperText>{helperText}</FormHelperText>}
            </FormControl>
        </Box>
    )
}